<template>
  <b-icon :icon="icon" v-if="icon !== null"/>
</template>

<script>
export default {
  name: "Icon",
  props: ['icon']
}
</script>

<style scoped>

</style>